<svelte:options accessors/>
<script lang="ts">
    import NauiExplorer from "../../naui/pages/NauiExplorer.svelte";


    export let data;
    export let columns;
    export let filters;
    export let actions;
    export let hideCount;
    export let searchLabel;
    export let editColumns;
    export let count;

</script>


<div>
    <NauiExplorer {data} {columns} {filters} {actions} {hideCount} {searchLabel} {editColumns} {count}/>
</div>